<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="My purse" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <section class="account">
      <div class="account_header">
        <p>Balance (dollar)</p>
        <div class="predeposit ">
          <span class="available_predeposit" @click="$router.push({ name: 'MemberPredepositList' })">{{ available_predeposit }}</span>
          <span class="freeze_predeposit">Freeze balance:{{freeze_predeposit}}</span>
        </div>
        <div class="card">
          <div class="card_item" @click="$router.push({ name: 'MemberVoucherList', query: { index: 0 } })">Voucher {{voucher_count}}</div>
          <div class="card_item">Recharge card balance {{available_rc_balance}}</div>
          <div class="card_item" @click="$router.push({name:'MemberPointList'})">Integral {{points}}</div>
        </div>
      </div>
      <div class="predeposit_handle mt-5">
        <div @click="$router.push({name:'MemberRechargeList'})"><i class="iconfont">&#xe624;</i>Recharge</div>
        <div @click="$router.push({name:'MemberWithdrawList'})"><i class="iconfont">&#xe6a5;</i>Withdraw</div>
      </div>
      <div class="menu mt-5">
        <div @click="$router.push({name:'MemberPointsOrderList'})"><mt-cell class="menu-item" title="Redeem" is-link></mt-cell></div>
        <div @click="$router.push({name:'MemberBankList'})"><mt-cell class="menu-item" title="Withdrawal account" is-link></mt-cell></div>
        <div @click="$router.push({name:'MemberRechargeCardList'})"><mt-cell class="menu-item" title="My top-up card" is-link></mt-cell></div>
        <div @click="$router.push({name:'MemberBonusreceive'})"><mt-cell class="menu-item" title="Red envelope collection record" is-link></mt-cell></div>
      </div>
    </section>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { getMemberIndex } from '../../../api/member'
import { mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      available_predeposit: 0.00,
      freeze_predeposit: 0.00,
      voucher_count: 0,
      points: 0,
      available_rc_balance: 0
    }
  },
  created () {
    getMemberIndex().then(
      response => {
        if (response && response.result.member_info) {
          this.available_predeposit = response.result.member_info.available_predeposit
          this.freeze_predeposit = response.result.member_info.freeze_predeposit
          this.voucher_count = response.result.member_info.voucher_count
          this.points = response.result.member_info.member_points
          this.available_rc_balance = response.result.member_info.available_rc_balance
        }
      },
      error => {}
    )
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
 .account{
   padding: .7rem;
   .account_header{
     width: 100%;
     border-radius: .5rem;
     background-color: #0196fd;
     color: #fff;
     -webkit-box-shadow: 0 .2rem .9rem rgba(0,128,248,.4)!important;
     box-shadow: 0 .2rem .9rem rgba(0,128,248,.4)!important;
     padding: .7rem;
     font-size: .6rem;
     box-sizing: border-box;
     .predeposit{
       padding: .5rem 0;
       .available_predeposit{
         font-size: .8rem;
       }
       .freeze_predeposit{
         float: right;
         padding: .1rem .5rem;
         border: 1px solid #80ccff;
         border-radius: .5rem;
         font-size: .5rem;
       }
     }
     .card{
       margin-top: 1rem;
       overflow: hidden;
       .card_item{
         float: left;
         width: 33%;
       }
       .card_item:nth-child(2){
         text-align: center;
       }
       .card_item:nth-child(3){
         text-align: right;
       }
     }
   }
   .predeposit_handle{
     border-radius: .2rem;
     background-color: #fff;
     padding: .7rem;
     text-align: center;
     overflow: hidden;
     font-size: .7rem;
     div{
       text-align: center;
       float: left;
       width: 50%;
       i{
         margin: 0 .2rem ;
       }
     }
     div:nth-child(1){
       width: 49%;
      border-right: 1px solid #e6e6e6;
     }
   }
   .menu{
     padding: .3rem 0 .5rem;
     background: #fff;
     border-radius: .2rem;
   }
 }
</style>
